import { Route, Routes, useLocation } from 'react-router-dom';
import SiteHeader from './components/SiteHeader';
import SiteFooter from './components/SiteFooter';
import AuthGate from './components/AuthGate';
import Home from './pages/Home';
import Legal from './pages/Legal';
import CreateOrder from './pages/CreateOrder';
import PayGuide from './pages/PayGuide';
import SubmitXianyu from './pages/SubmitXianyu';
import Studio from './pages/Studio';
import OrderDetail from './pages/OrderDetail';
import MyOrders from './pages/MyOrders';
import AdminLogin from './pages/AdminLogin';
import AdminOrders from './pages/AdminOrders';
import AdminOrderDetail from './pages/AdminOrderDetail';
import AdminConfig from './pages/AdminConfig';
import AdminUsers from './pages/AdminUsers';
import Login from './pages/Login';
import Register from './pages/Register';

function AppShell() {
  const { pathname } = useLocation();
  const fullBleed =
    pathname === '/' ||
    pathname.startsWith('/legal/');

  return (
    <div className="app-shell">
      <SiteHeader />
      <main className={fullBleed ? 'site-main-full' : 'site-main-shell'}>
        <div className={fullBleed ? undefined : 'shell'}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/legal/:doc" element={<Legal />} />
            <Route
              path="/order/new"
              element={
                <AuthGate>
                  <CreateOrder />
                </AuthGate>
              }
            />
            <Route
              path="/order/:code/pay"
              element={
                <AuthGate>
                  <PayGuide />
                </AuthGate>
              }
            />
            <Route
              path="/order/:code/xianyu"
              element={
                <AuthGate>
                  <SubmitXianyu />
                </AuthGate>
              }
            />
            <Route
              path="/order/:code/studio"
              element={
                <AuthGate>
                  <Studio />
                </AuthGate>
              }
            />
            <Route
              path="/order/:code"
              element={
                <AuthGate>
                  <OrderDetail />
                </AuthGate>
              }
            />
            <Route
              path="/account/orders"
              element={
                <AuthGate>
                  <MyOrders />
                </AuthGate>
              }
            />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/admin/orders/:id" element={<AdminOrderDetail />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/config" element={<AdminConfig />} />
          </Routes>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}

export default function App() {
  return <AppShell />;
}
